import React from 'react';

export const TableHeader = ({ title, isMobile }) => (
    <thead className="kt-datatable__head">
    <tr className="kt-datatable__row">
        <th colSpan="3" className="kt-datatable__cell kt-datatable__title" style={{textAlign: 'center'}}>
            {title}
        </th>
    </tr>
    {!isMobile && (
        <tr className="kt-datatable__row">
            <th width="200px" className="kt-datatable__cell"><span>Наименование</span></th>
            <th width="auto" className="kt-datatable__cell"></th>
            <th width="200px" style={{textAlign: 'center'}} className="kt-datatable__cell"><span>Остаток (факт.)</span></th>
        </tr>
    )}
    </thead>
);